import { useMatrixSettingsContext } from '@app/components/products/ProductMatrix/context';
import { CustomImage } from '@app/components/various/CustomImage';
import { ContentPlaceholder } from '@app/components/various/Icons';
import { ImageMagnifier } from '@app/components/various/ImageMagnifier';
import { getImageForVariant } from '@app/ducks/helpers';
import { cn } from '@app/utils/cn';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { Product } from '@typings';
import React from 'react';
import { useSelector } from 'react-redux';

interface Props {
  variant: Product.Standard;
  className?: string;
}

export const VariantImage = ({ variant, className }: Props) => {
  const { productConfiguration } = useMatrixSettingsContext();
  const imageForVaiantSelector = React.useMemo(() => getImageForVariant(variant), [variant]);
  const image = useSelector(imageForVaiantSelector);
  if (isDefined(productConfiguration)) {
    return null;
  }

  const hasImage = !isEmpty(image.src);

  const commonClassNames = `h-[--matrixCellHeight] w-12`;

  return (
    <div
      className={cn(
        'flex-shrink-0 overflow-hidden rounded-small',
        commonClassNames,
        {
          'flex items-center justify-center bg-neutral-96': !hasImage,
        },
        className,
      )}
    >
      {hasImage ?
        <ImageMagnifier src={image.src} title={variant.variantName}>
          <CustomImage aspectRatio={1} src={image.src} placeholderClassName={commonClassNames} size="cover" />
        </ImageMagnifier>
      : <ContentPlaceholder className="size-8 text-neutral-80" />}
    </div>
  );
};
